import { Icon } from "semantic-ui-react";
import React from "react";
import styles from "./RemoveButton.module.scss";

type Props = {
  onClick: () => void;
};

export const RemoveButton = ({ onClick }: Props) => {
  return (
    <div className={styles.button} data-testid="removeButton">
      <Icon className={"minus circle"} size={"big"} color={"blue"} onClick={onClick} />
    </div>
  );
};
